<script setup>
import { onBeforeUnmount } from 'vue'
import { useEcusStore } from '@/stores/ecus'

const ecusStore = useEcusStore()

const props = defineProps({
    uuid: {
        type: String,
        required: true
    }
})

ecusStore.readEcus({uuid_car_array: props.uuid})

onBeforeUnmount(() => {

    ecusStore.resetEcus()
})

</script>

<template>
    <div class="uta-ecus">
        <router-view />
    </div>
</template>